import apiClient from '@/services/axios'

export async function get( venueDetailsId, from, to) {

  var params = { 'venue-details-id': venueDetailsId ? venueDetailsId.id : null, 'from-date': from, 'to-date': to }

  var response = await apiClient.get(process.env.VUE_APP_MARCOM_API_BASE_URL + '/admin/events', { params: params });

  if (response) {
    console.log(response)
    return response.data;
  }

  throw new Error('Unable to get events')
}
